import {
  HelpCircle,
  Copy,
  Route,
  Upload,
  FolderX,
  StopCircle,
} from "lucide-react";
import { AppColorVariant } from "../theme/AppColorVariant";

export enum FileFailureType {
  None = "0",
  FileAlreadyExists = "fileAlreadyExists",
  TooLongSharepointFilePath = "tooLongSharepointFilePath",
  UploadFailed = "uploadFailed",
  DirectoryNotFound = "directoryNotFound",
  OperationCanceled = "operationCanceled",
  Unknown = "unknown",
}

export const FileFailureTypeLabels: Record<FileFailureType, string> = {
  [FileFailureType.None]: "",
  [FileFailureType.Unknown]: "Unknown",
  [FileFailureType.FileAlreadyExists]: "Already Exists",
  [FileFailureType.TooLongSharepointFilePath]: "Path too long",
  [FileFailureType.UploadFailed]: "Upload Failed",
  [FileFailureType.DirectoryNotFound]: "Directory Not Found",
  [FileFailureType.OperationCanceled]: "Operation Canceled",
};

export const FileFailureTypeColors: Record<FileFailureType, AppColorVariant> = {
  [FileFailureType.None]: "primary",
  [FileFailureType.Unknown]: "warning",
  [FileFailureType.FileAlreadyExists]: "pink",
  [FileFailureType.TooLongSharepointFilePath]: "primary",
  [FileFailureType.UploadFailed]: "danger",
  [FileFailureType.DirectoryNotFound]: "neutral",
  [FileFailureType.OperationCanceled]: "yellow",
};

export const FileFailureTypeIcons: Record<FileFailureType, React.ElementType> = {
  [FileFailureType.None]: HelpCircle,
  [FileFailureType.Unknown]: HelpCircle,
  [FileFailureType.FileAlreadyExists]: Copy,
  [FileFailureType.TooLongSharepointFilePath]: Route,
  [FileFailureType.UploadFailed]: Upload,
  [FileFailureType.DirectoryNotFound]: FolderX,
  [FileFailureType.OperationCanceled]: StopCircle,
};
